import {_pushHash, _replaceHash} from "./foreign.js";
const replaceHash = dictMonadEffect => h => dictMonadEffect.liftEffect(() => _replaceHash(h));
const pushHash = dictMonadEffect => h => dictMonadEffect.liftEffect(() => _pushHash(h));
export {pushHash, replaceHash};
export * from "./foreign.js";
